export { default as Parameters } from "./parameters"



// WEBPACK FOOTER //
// ./src/core/components/parameters/index.js